import { render, staticRenderFns } from "./SalesOrderDetail.vue?vue&type=template&id=2ab9146b&scoped=true"
import script from "./SalesOrderDetail.vue?vue&type=script&lang=js"
export * from "./SalesOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./SalesOrderDetail.vue?vue&type=style&index=0&id=2ab9146b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab9146b",
  null
  
)

export default component.exports